module.exports = __webpack_public_path__ + "static/media/4bhk.ef1c01f2.png";